export default {
  TOGGLE_TIMELINE: 'TOGGLE_TIMELINE',
  SET_STATUS_HEADER_HEIGHT: 'SET_STATUS_HEADER_HEIGHT',
  RESET_STATUS_HEADER: 'RESET_STATUS_HEADER'
}
